import React, { useState } from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    ZoomableGroup
} from "react-simple-maps";
import { geoPath } from "d3-geo";
import { geoTimes } from "d3-geo-projection";

const geoUrl =
    "./features.json";
var loca1 = [0, 0]



const MapChart = ({ setTooltipContent }) => {
    const [zoom, setZoom] = useState(1);
    const [center, setCenter] = useState([0, 0]);
    const [dummycenter, setDummyCenter] = useState([0, 0]);


    const handleGeographyClick = (geography, projection, path) => event => {
        // console.log("handleGeographyClick")
        const centroid = projection.invert(path.centroid(geography));
        // console.log(loca1)
        // setCenter(centroid);
        setCenter([0, 0])
        setCenter(loca1)
        setZoom(4);
    };

    const projection = () => {
        return geoTimes()
            .translate([800 / 2, 450 / 2])
            .scale(160);
    };


    const doNothing = (geography, projection, path) => (event) => {

    };

    const gotoMap = () => {
        // console.log("Clicked")
        setCenter(loca1);

    }

    const handleLoad = (selectedcountry, requiredcountry, geography, projection, path) => {
        //console.log(selectedcountry)
        //console.log(requiredcountry)


        //const centroid = projection.invert(path.centroid(geography));

        if (selectedcountry == requiredcountry) {
            // console.log("Loaded geographies")
            const centroid = projection.invert(path.centroid(geography));
            // console.log(centroid)
            loca1 = centroid
            // console.log(requiredcountry)
        }


        // if (selectedcountry == requiredcountry) {
        //     console.log("Loaded geographies")
        //     console.log(requiredcountry)



        //     console.log("Called")
        //     const centroid = projection.invert(path.centroid(geography));
        //     setCenter(centroid);
        //     setZoom(4);
        // }
        // if (selectedcountry == requiredcountry) {
        //     console.log("Loaded geographies")
        //     console.log(requiredcountry)
        //     const centroid = projection.invert(path.centroid(geography));
        //     setCenter(centroid);
        //     setZoom(4);

        // }

    }


    return (

        <ComposableMap

            projectionConfig={{
                rotate: [-80, -32, 0],
                scale: 200

            }}
        >


            <ZoomableGroup center={center} zoom={zoom}>
                <Geographies geography="./features.json">
                    {({ geographies, projection, path }) =>
                        geographies.map((geography) => {
                            const isClicked = "Germany" === geography.properties.name;

                            return (

                                <Geography
                                    key={geography.rsmKey}
                                    geography={geography}
                                    fill={isClicked ? "green" : "grey"}
                                    onClick={handleGeographyClick(geography, projection, path)}
                                    outline="none"
                                    geographypathsloaded={handleLoad(geography.properties.name, "Germany", geography, projection, path)}

                                />


                            );
                        })

                    }
                </Geographies>
            </ZoomableGroup>
        </ComposableMap>
    );
};

export default MapChart;


